"use client";

import { useEffect, useState } from "react";

const LipscoreServiceSmall = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  return (
    <>
      <style type="text/css">
        {`
                .lipscore-service-review-badge-small-long svg, .lipscore-service-review-badge-small-long svg * {
                    fill: #FFFFFF !important;
                }
            `}
      </style>
      <div
        className="lipscore-service-review-badge-small-long lipscore-no-border lipscore-no-separator"
        data-ls-widget-height="35px"
        data-ls-widget-width="300px"
      ></div>
    </>
  );
};

export default LipscoreServiceSmall;
